import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAngleLightUp = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m20.982 19.198 13.403 13.61a1.388 1.388 0 0 1 0 1.964l-.82.82a1.388 1.388 0 0 1-1.965 0L20 23.774 8.4 35.581a1.388 1.388 0 0 1-1.964 0l-.82-.82a1.388 1.388 0 0 1 0-1.964l13.402-13.61a1.398 1.398 0 0 1 1.964.01Zm-1.964-14.79L5.615 18.02a1.388 1.388 0 0 0 0 1.964l.82.82a1.388 1.388 0 0 0 1.965 0L20 8.984l11.6 11.809a1.388 1.388 0 0 0 1.964 0l.82-.82a1.388 1.388 0 0 0 0-1.964L20.983 4.398a1.398 1.398 0 0 0-1.964.01Z" })
});
export default SvgAngleLightUp;
